import styled from 'styles/styled';

export const Wrap = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const Head = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 0 4px;
`;

export const SectionTitle = styled.div`
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7A7E8C;
  font-weight: 600;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  padding-right: 2px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #2A2E34;
    border-radius: 4px;
  }
`;

export const Row = styled.div<{ $me?: boolean }>`
  display: grid;
  grid-template-columns: 28px 1fr auto;
  column-gap: 8px;
  row-gap: 2px;
  align-items: center;
  padding: 8px 8px;
  border-radius: 8px;
  background: ${(p) => (p.$me ? 'rgba(82, 211, 129, 0.08)' : 'transparent')};
  border: 1px solid ${(p) => (p.$me ? 'rgba(82, 211, 129, 0.18)' : 'transparent')};
  transition: background 120ms;
`;

export const Rank = styled.div`
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #EFEFEF;
`;

export const Name = styled.div<{ $me?: boolean }>`
  font-size: 12px;
  font-weight: ${(p) => (p.$me ? 700 : 500)};
  color: #EFEFEF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Pct = styled.div<{ $pos?: boolean; $neg?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${(p) => (p.$pos ? '#52D381' : p.$neg ? '#FF6782' : '#A7A8B2')};
  white-space: nowrap;
`;

export const Amount = styled.div<{ $pos?: boolean; $neg?: boolean }>`
  grid-column: 2 / -1;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${(p) => (p.$pos ? '#52D381' : p.$neg ? '#FF6782' : '#EFEFEF')};
  white-space: nowrap;
`;

export const Empty = styled.div`
  font-size: 11px;
  color: #7A7E8C;
  text-align: center;
  padding: 16px 8px;
`;
